import React, { useState } from 'react';

interface FormData {
  name: string;
  email: string;
  phone: string;
  message: string;
}

const ContactForm: React.FC = () => {
  const [result, setResult] = React.useState('');
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setResult('שולח את ההודעה...');
    const formData = new FormData(event.target);

    formData.append('access_key', '0981b093-597b-4a13-9aa9-6ea6bef4af5f');

    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult('ההודעה נשלחה בהצלחה!');
      event.target.reset();
    } else {
      console.log('Error', data);
      setResult('אירעה שגיאה בשליחת ההודעה. אנא נסו שוב.');
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="text-right mb-6">
        <h2 className="text-2xl font-bold mb-2">צרו איתנו קשר</h2>
        <p className="text-gray-700">
          יש לכם שאלה? רוצים לשתף חוויה מהטיול? נשמח לשמוע מכם! אנחנו כאן כדי
          לעזור ולייעץ.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3" dir="rtl">
        <div
          style={{
            display: 'flex',
            direction: 'rtl',
            textAlign: 'right',
            flexDirection: 'column',
            gap: '10px',
            margin: '10px',
          }}
        >
          <input
            style={{ direction: 'rtl', textAlign: 'right' }}
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="טלפון"
            className="flex-1 px-4 py-2 border border-gray-300 rounded text-right"
            required
          />

          <input
            style={{ direction: 'rtl', textAlign: 'right' }}
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="אימייל"
            className="flex-1 px-4 py-2 border border-gray-300 rounded text-right"
            required
          />

          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="שם מלא"
            className="flex-1 px-4 py-2 border border-gray-300 rounded text-right"
            required
          />

          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="תוכן ההודעה"
            rows={4}
            className="w-full px-4 py-2 border border-gray-300 rounded text-right resize-none mb-3"
          />
          <button
            id="submit-button"
            type="submit"
            className="w-[300px] py-3 rounded bg-orange-500 hover:bg-orange-700 transition-colors duration-300 text-black"
            style={{
              backgroundColor: '#FFF',
              color: '#000',
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = 'rgb(255, 107, 107)')
            }
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#FFF')}
          >
            שליחה
          </button>
        </div>
      </form>
      {result && (
        <div
          className={`mt-6 p-4 rounded-md ${
            result.includes('בהצלחה')
              ? 'bg-green-50 text-green-800 border border-green-200'
              : result.includes('שולח')
              ? 'bg-blue-50 text-blue-800 border border-blue-200'
              : 'bg-red-50 text-red-800 border border-red-200'
          }`}
        >
          {result}
        </div>
      )}
    </div>
  );
};

export default ContactForm;
